// <s-card-swatches> previews a color's variant photo in its product card and points the
// card's links at that variant. Swatch buttons carry data-src/data-srcset/data-url from Liquid.
class CardSwatches extends HTMLElement {
  #controller;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

    this.addEventListener('click', (event) => {
      const button = event.target.closest('button[aria-pressed]');
      if (!button || !this.contains(button)) return;
      event.preventDefault();
      this.#select(button);
    }, { signal });

    this.addEventListener('pointerover', (event) => {
      if (!finePointer.matches) return;
      const button = event.target.closest('button[aria-pressed]');
      if (button && this.contains(button)) this.#select(button);
    }, { signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #select(button) {
    if (button.getAttribute('aria-pressed') === 'true') return;
    const card = this.closest('article');
    if (!card) return;

    for (const other of this.querySelectorAll('button[aria-pressed]')) {
      other.setAttribute('aria-pressed', other === button ? 'true' : 'false');
    }

    const { src, srcset, url, width, height } = button.dataset;
    const image = card.querySelector('a img');
    if (image && src) {
      image.srcset = srcset || '';
      image.src = src;
      if (this.dataset.sizes) image.sizes = this.dataset.sizes;
      if (width) image.width = Number(width);
      if (height) image.height = Number(height);
      image.loading = 'eager';
    }

    if (url) {
      for (const link of card.querySelectorAll('a[href]')) link.href = url;
    }
  }
}

if (!customElements.get('s-card-swatches')) {
  customElements.define('s-card-swatches', CardSwatches);
}
